export function formatDate(
  iso?: string | null,
): string {
  if (!iso) return '';
  const date = new Date(iso);
  return date.toLocaleDateString(undefined, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
}

export function truncateText(
  str: string | null | undefined, 
  n: number = 200
): string | null | undefined {
  if (str == null) return str;

  return str.length > n
    ? `${str.slice(0, n - 1).trimEnd()}…`
    : str;
};